import axios from "axios";
import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const SideNavBar = () => {
     const location = useLocation();
     const [permissions, setPermissions] = useState([]);
      console.log("Permissions", permissions);

  const getActiveScope = (pathname) => {
    if (pathname === '/' || pathname === '/new-dashboard' || pathname === '/old-dashboard') return 'dashboard';
    if (pathname.startsWith('/add-courses') || pathname.startsWith('/course-list')) return 'courses';
    if (pathname.startsWith('/create-job') || pathname.startsWith('/job-list') || pathname.startsWith('/job-application')) return 'placements';
    if (pathname.startsWith('/partner-list') || pathname.startsWith('/projects') || pathname.startsWith('/interview-schedule') || pathname.startsWith('/request-training')) return 'partners';
    if (pathname.startsWith('/role-management') || pathname.startsWith('/user-role-management') || pathname.startsWith('/role-permission-management')) return 'access-control';
    if (pathname.startsWith('/IssueList') || pathname.startsWith('/IssueCommunication')) return 'issue-listings';
    if (pathname.startsWith('/hr-actions')) return 'hr-actions';
    if (pathname.startsWith('/hr-list')) return 'hr-list';
    if (pathname.startsWith('/create-hr')) return 'hr-list';
    return null;
  };

  const scope = getActiveScope(location.pathname);

  useEffect(() => {
    if (scope !== 'dashboard') {
      document.body.classList.add("has-sidebar");
    } else {
      document.body.classList.remove("has-sidebar");
    }
    return () => {
      document.body.classList.remove("has-sidebar");
    };
  }, [scope]);

useEffect(() => {

    console.log("useEffect Running");

    const loadPermission = async () => {

        try {

            const roleId = localStorage.getItem("role_id");

            console.log("ROLE ID =>", roleId);
console.log(
  "TOKEN =>",
  localStorage.getItem("token")
);

            // Multi-role support: prefer stored role_ids list,
            // fall back to single role_id
            let roleParam = roleId;

            const storedRoleIds =
                localStorage.getItem("role_ids");

            if (storedRoleIds) {

                try {

                    const parsed =
                        JSON.parse(storedRoleIds);

                    if (
                        Array.isArray(parsed) &&
                        parsed.length > 0
                    ) {

                        roleParam = parsed.join(",");

                    }

                } catch (err) {

                    console.log(err);

                }

            }

            console.log("Role Id", roleParam);

           const API_URL = process.env.REACT_APP_API_URL;

const res = await axios.get(
 `${API_URL}api/admin/role-permissions/${roleParam}`
);

console.log("PERMISSION RESPONSE =>", res.data);

console.log("API Response =>", res.data);

setPermissions(
    res.data.permissions || []
);

console.log(
  "Loaded Permissions =>",
  res.data.permissions
);

        } catch (err) {

    console.log(
      "FULL ERROR =>",
      err.response
    );

}

    };

    loadPermission();

}, []);

const expandSidebar = () => {
    const wrapper = document.getElementById("wrapper");

    document.body.classList.remove("enlarged");
    document.body.classList.add("sidebar-enable");

    if (wrapper) {
        wrapper.classList.remove("toggled");
    }
};
     

    const [menuItems, setMenuItems] = useState([
     {
    label: 'Dashboard',
    isOpen: false,
    iconClass: "fe-box",
    subMenuItems: [
        {
            label: "New Dashboard",
            path: "/",
            iconClass: "fe-grid",
            isOpen: false
        },
        {
            label: "Old Dashboard",
            path: "/old-dashboard",
            iconClass: "fe-home",
            isOpen: false
        }
    ]
},
        {
            label: 'Business', isOpen: false,
            iconClass: "fe-box",
            subMenuItems: [
                { label: 'Business List', path: '/BusinessList', iconClass: 'fe-clock', isOpen: false },
                { label: 'Add Business', path: '/addNewBusiness', iconClass: 'fe-clock', isOpen: false },
            ]
        },
        {
            label: 'Courses',
            isOpen: false,
            iconClass: 'fe-briefcase',
            subMenuItems: [
                { label: 'Add Courses', path: '/add-courses', iconClass: 'fe-clock', isOpen: false },
                { label: 'Course List', path: '/course-list', iconClass: 'fe-clock', isOpen: false },
            ]
            
        },
        {
            label: 'Placements',
            isOpen: false,
            iconClass: 'fe-briefcase',
            subMenuItems: [
                { label: 'Create a Job', path: '/create-job', iconClass: 'fe-clock', isOpen: false },
                { label: 'Job List', path: '/job-list', iconClass: 'fe-clock', isOpen: false },
                { label: 'Job Application', path: '/job-application', iconClass: 'fe-clock', isOpen: false },
            ]
            
        },

       {
    label: 'Partners',
    isOpen: false,
    iconClass: 'fe-users',
    subMenuItems: []
},

        // {
        //     label: 'Partners',
        //     isOpen: false,
        //     iconClass: 'fe-users',
        //     subMenuItems: [
                    
                    
                    

              
        //     ]
        // },



        {
    label: 'Access Control',
    isOpen: false,
    iconClass: 'fe-shield',
    subMenuItems: [
        {
            label: 'Role Management',
            path: '/role-management',
            iconClass: 'fe-users',
            isOpen: false
        },
        {
            label: 'User Role Management',
            path: '/user-role-management',
            iconClass: 'fe-user-check',
            isOpen: false
        },
        {
            label: 'Role Permission Management',
            path: '/role-permission-management',
            iconClass: 'fe-settings',
            isOpen: false
        }
    ]
},

        {
            label: 'Geography', isOpen: false,
            iconClass: "fe-box",
            subMenuItems: [
                { label: 'Country List', path: '/CountryListing', iconClass: 'fe-clock', isOpen: false },
                { label: 'State List', path: '/StateList', iconClass: 'fe-clock', isOpen: false },
                { label: 'District List', path: '/DistrictList', iconClass: 'fe-clock', isOpen: false },
            ]
        },
        {
            label: 'Customer Data', isOpen: false,
            iconClass: "fe-box",
            subMenuItems: [
                { label: 'UserGroup List', path: '/GroupList', iconClass: 'fe-clock', isOpen: false },
                { label: 'GroupCustomerData List', path: '/GroupCustomerDataList', iconClass: 'fe-clock', isOpen: false },
                { label: 'CustomerData List', path: '/CustomerDataList', iconClass: 'fe-clock', isOpen: false },
            ]
        },
        {
            label: 'Manage Service Plan', isOpen: false,
            iconClass: "fe-box",
            subMenuItems: [
                { label: 'Add Services', path: '/addservice', iconClass: 'fe-clock', isOpen: false },
                { label: 'Add package', path: '/addpackage', iconClass: 'fe-clock', isOpen: false },
                { label: 'Add Feature', path: '/addfeature', iconClass: 'fe-clock', isOpen: false },
                { label: 'Add Plan', path: '/addplan', iconClass: 'fe-clock', isOpen: false },
                { label: 'Feature List', path: '/featureList', iconClass: 'fe-clock', isOpen: false },
                { label: 'Services List', path: '/service-list', iconClass: 'fe-clock', isOpen: false },
                { label: 'Package List', path: '/package-list', iconClass: 'fe-clock', isOpen: false },
                { label: 'CustomerData List', path: '/CustomerDataList', iconClass: 'fe-clock', isOpen: false },
            ]
        },
        // {
        //     label: 'Manage Whatsapp Credential', isOpen: false,
        //     iconClass: "fe-box",
        //     subMenuItems: [
        //         { label: 'Create Credential', path: '/insert-whatsapp-credential', iconClass: 'fe-clock', isOpen: false },
        //         { label: 'Credential List', path: '/whatsapp-credential-listing', iconClass: 'fe-clock', isOpen: false },
        //     ]
        // },
        {
            label: 'Issue Listing', isOpen: false,
            iconClass: "fe-box",
            path: '/IssueList'
        },
        {
            label: 'HR ACTIONS', isOpen: false,
            iconClass: "fe-activity",
            path: '/hr-actions'
        },
        {
            label: 'HR LIST', isOpen: false,
            iconClass: "fe-users",
            path: '/hr-list'
        },
        {
            label: 'Create HR', isOpen: false,
            iconClass: "fe-user-plus",
            path: '/create-hr'
        },

        {
            label: 'Bought Contacts', isOpen: false,
            iconClass: "fe-box",
            subMenuItems: [
                { label: 'Create Buy-Contacts Plan', path: '/create-contact-plan', iconClass: 'fe-clock', isOpen: false },
                { label: 'Buy-Contacts Plan-List', path: '/contact-plan', iconClass: 'fe-clock', isOpen: false },
            ]

        },
        {
            label: 'Setting', isOpen: false,
            iconClass: "fe-box",
            subMenuItems: [
                { label: 'Application', path: '/preference', iconClass: 'fe-clock', isOpen: false },
            ]

        },
        {
            label: 'Buy Request', isOpen: false,
            iconClass: "fe-box",
            subMenuItems: [
                { label: 'Requests Buy Contacts', path: '/buy-contacts-request', iconClass: 'fe-clock', isOpen: false },
                { label: 'Requests Buy Plan', path: '/buy-plan-request', iconClass: 'fe-clock', isOpen: false },
            ]

        },
    ]);

    const updatedMenuItems = menuItems.map((item) => {

    if (item.label === "Partners") {

        return {
            ...item,
            subMenuItems: [
                permissions.includes("partner_list") && {
                    label: "Partner List",
                    path: "/partner-list",
                    iconClass: "fe-user"
                },

                permissions.includes("admin-projects") && {
                    label: "Projects",
                    path: "/projects",
                    iconClass: "fe-folder"
                },

                permissions.includes("interview_schedule") && {
                    label: "Interview Schedule",
                    path: "/interview-schedule",
                    iconClass: "fe-calendar"
                },

                permissions.includes("request_training") && {
                    label: "Request Training",
                    path: "/request-training",
                    iconClass: "fe-user"
                }

            ].filter(Boolean)
        };
    }

    if (item.label === "Courses") {
    return {
        ...item,
        subMenuItems: [
            permissions.includes("add_course") && {
                label: "Add Courses",
                path: "/add-courses",
                iconClass: "fe-clock"
            },

            permissions.includes("course_list") && {
                label: "Course List",
                path: "/course-list",
                iconClass: "fe-clock"
            }
        ].filter(Boolean)
    };
}

if (item.label === "Placements") {
    return {
        ...item,
        subMenuItems: [
            permissions.includes("create_job") && {
                label: "Create a Job",
                path: "/create-job",
                iconClass: "fe-clock"
            },

            permissions.includes("job_list") && {
                label: "Job List",
                path: "/job-list",
                iconClass: "fe-clock"
            },

            permissions.includes("job_application") && {
                label: "Job Application",
                path: "/job-application",
                iconClass: "fe-clock"
            }
        ].filter(Boolean)
    };
}

    return item;
});

console.log(
    "Updated Menu =>",
    updatedMenuItems
);

console.log(
  "Partners Menu",
  updatedMenuItems.find(
    item => item.label === "Partners"
  )
);


  const scopeLabelMap = {
    'courses': 'Courses',
    'placements': 'Placements',
    'partners': 'Partners',
    'access-control': 'Access Control',
    'issue-listings': 'Issue Listing',
    'hr-actions': 'HR ACTIONS',
    'hr-list': 'HR LIST'
  };

  // HR section: HR ACTIONS + HR LIST + Create HR are always shown together
  // (in menuItems order) so Admin can move between the HR pages. All other
  // scopes keep showing only their own single item, as before.
  const SCOPE_GROUP_LABELS = {
    'hr-actions': ['HR ACTIONS', 'HR LIST', 'Create HR'],
    'hr-list': ['HR ACTIONS', 'HR LIST', 'Create HR'],
  };

    const visibleLabels = SCOPE_GROUP_LABELS[scope]
      || (scopeLabelMap[scope] ? [scopeLabelMap[scope]] : []);

    const showSideNavList = updatedMenuItems.map((item, index) => {
      if (scope && scope !== 'dashboard' && !visibleLabels.includes(item.label)) {
        return null;
      }
      return (
        <li
    key={index}
    className={
        item.subMenuItems?.some(
            sub => sub.path === location.pathname
        )
            ? 'mm-active'
            : item.path === location.pathname
            ? 'mm-active'
            : ''
    }
>
    

    <Link
    to={item?.path ? item.path : "#"}
    className={
        item.path === location.pathname ||
        item.subMenuItems?.some(sub => sub.path === location.pathname)
            ? "active"
            : ""
    }
    onClick={(e) => {

        // Agar submenu hai to page navigate mat karo
        if (item.subMenuItems) {
            e.preventDefault();
        }

        // Sidebar collapsed hai to pehle expand karo
        if (document.body.classList.contains("enlarged")) {

            document.body.classList.remove("enlarged");
            document.body.classList.add("sidebar-enable");

            const wrapper = document.getElementById("wrapper");

            if (wrapper) {
                wrapper.classList.remove("toggled");
            }
        }

        handleMenuItemClick(index);

    }}
>
                <i className={item.iconClass}></i>
                <span>{item.label}</span>
                {item?.path ? '' : <span className="menu-arrow"></span>}

            </Link>

            {item.subMenuItems && (
                <ul
                    className={
    item.subMenuItems?.some(
        sub => sub.path === location.pathname
    ) || item.isOpen
        ? 'nav-second-level mm-collapse mm-show'
        : 'nav-second-level mm-collapse'
}
                    aria-expanded={item.isOpen ? 'true' : 'false'}
                >
                    {item.subMenuItems.map((subItem, subIndex) => (
                        <li
    key={subIndex}
    className={
        location.pathname === subItem.path
            ? 'mm-active'
            : ''
    }
>
                            <Link
    to={subItem.path}
    onClick={() => {

        if (document.body.classList.contains("enlarged")) {

            document.body.classList.remove("enlarged");
            document.body.classList.add("sidebar-enable");

            const wrapper = document.getElementById("wrapper");

            if (wrapper) {
                wrapper.classList.remove("toggled");
            }
        }

        handleSubMenuItemClick(subIndex,index);

    }}
>
                                <i className={subItem.iconClass}></i>&nbsp;&nbsp;
                                <span>{subItem.label}</span>
                            </Link>
                        </li>
                    ))}
                </ul>
            )}
        </li>
      );
    })

const handleMenuItemClick = (index) => {

    // Agar sidebar collapsed hai to pehle expand karo
    if (document.body.classList.contains("enlarged")) {
        expandSidebar();
    }

    const updatedItems = [...menuItems];

    updatedItems.forEach((item, i) => {
        item.isOpen = i === index ? !item.isOpen : false;
    });

    setMenuItems(updatedItems);
};

    const handleSubMenuItemClick = (subIndex, index) => {
        const updatedSubMenuItems = [...menuItems];
        for (let i = 0; i < updatedSubMenuItems[index].subMenuItems.length; i++) {
            if (subIndex == i) {
                updatedSubMenuItems[index].subMenuItems[i].isOpen = true;
            }
            else {
                updatedSubMenuItems[index].subMenuItems[i].isOpen = false;
            }
        }
        setMenuItems(updatedSubMenuItems);
    }
    if (scope === 'dashboard') return null;

    return (
        <div id="wrapper">
            <div className="left-side-menu">

                <div className="slimscroll-menu">

                 
                    <div id="sidebar-menu">

                        <ul className="metismenu siderbr-menu-txt" id="side-menu">

                            <li className="menu-title">Navigation</li>
                            {/* ponytail: return to dashboard link */}
                            <li>
                                <Link to="/" className="sidebar-back-btn" aria-label="Return to Dashboard">
                                    <i className="fe-arrow-left"></i>
                                    <span>Return to Dashboard</span>
                                </Link>
                            </li>
                            {showSideNavList}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}


export default SideNavBar;